import styled, { css } from 'styled-components';

export const TipContainer = styled.div`
	${({ theme }) => css`
		height: 68px;
		display: grid;

		padding: 10px;

		box-shadow: ${theme.shadows.base};
		background-color: rgba(255, 255, 255, 0.5);
		border-radius: ${theme.radii.m};
	`}
`;

export const TipText = styled.div`
	${({ theme }) => css`
		font-size: ${theme.fontSizes.default};
		line-height: 21px;
		padding-right: 12px;
	`}
`;
